import { cva, type VariantProps } from 'class-variance-authority';
import { type ComponentProps, memo } from 'react';

import { cn } from '@/shared/utils/cn';

const profileDetailsRootVariants = cva(
  'relative flex w-full touch-pan-y flex-col gap-4',
  {
    variants: {
      variant: {
        default: '',
        card: 'p-2 bg-cold-950',
      },
    },
    defaultVariants: {
      variant: 'card',
    },
  },
);

export interface ProfileDetailsRootProps
  extends
    ComponentProps<'div'>,
    VariantProps<typeof profileDetailsRootVariants> {}

export const ProfileDetailsRoot = memo(function ProfileDetailsRoot(
  props: ProfileDetailsRootProps,
) {
  const { children, className, variant, ...rest } = props;

  return (
    <div
      {...rest}
      className={cn(profileDetailsRootVariants({ variant }), className)}
    >
      {children}
    </div>
  );
});
